'use client';

import { useEffect } from 'react';

export function ScrollToTop() {
    useEffect(() => {
        const url = new URL(window.location.href);
        const { hash } = url;

        if (!hash) {
            window.scrollTo(0, 0);
        }
    }, []);

    return null;
}
